var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHighlight = function SvgHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.197 6.055l.824-.798 1.648 1.596-.824.798-1.648-1.596zm-3.297 0l1.648-1.596.824-.798a2.385 2.385 0 013.297 0l1.648 1.596c.91.882.91 2.31 0 3.192l-.824.798-1.648 1.596-4.12 3.99-1.65 1.596-.193.188-3.112 1.127a2.384 2.384 0 01-2.463-.517 2.204 2.204 0 01-.534-2.385l1.164-3.013.194-.188 1.648-1.596 4.121-3.99zm3.297 3.192l-4.121 3.99-1.648-1.596 4.12-3.99 1.649 1.596zm-8.24 6.382l.897-2.32 1.5 1.452-2.397.868zm-1.791 3.114c-.644 0-1.166.505-1.166 1.129C4 20.495 4.522 21 5.166 21h12.82c.644 0 1.166-.505 1.166-1.128 0-.624-.522-1.13-1.166-1.13H5.166z"
  })));
};

export default SvgHighlight;